import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function UnderWindLRow() {
   return (
      <InputRangeRow
         titleProp={"Underwind L"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={10}
         propertyNameProp={"underwindL"}
         errorDialogueProp={"0.00-10.00 only"}
         floatProp={true}
      />
   );
}
